import React from "react"
import * as Chakra from "@chakra-ui/react"

interface ProjectPullquoteProps {
  text?: string
}

const ProjectPullquote = React.forwardRef(
  (props: ProjectPullquoteProps, ref) => {
    return (
      <Chakra.Box
        ref={ref}
        width="100%"
        display="flex"
        position="relative"
        alignItems="center"
        flexDirection="column"
        backgroundColor="transparent"
      >
        <Chakra.Box
          width="100%"
          display="flex"
          maxWidth="1800px"
          alignItems="center"
          marginLeft="auto"
          paddingTop="60px"
          marginRight="auto"
          paddingLeft="40px"
          paddingRight="40px"
          paddingBottom="120px"
          justifyContent="center"
          backgroundColor="transparent"
          css={{
            "@media (max-width: 767px)": {
              paddingLeft: "20px",
              paddingRight: "20px",
            },
          }}
        >
          <Chakra.Box
            as="span"
            fontSize="36px"
            maxWidth="896px"
            textAlign="center"
            fontFamily="BeausiteClassic-Clear"
            lineHeight="43.2px"
          >
            {props.text}
          </Chakra.Box>
        </Chakra.Box>
      </Chakra.Box>
    )
  }
)

ProjectPullquote.pressless = {
  name: "Project Pullquote",
  attributes: {
    text: {
      name: "Text",
      type: "RichText",
      placeholder:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ultricies lorem quisque amet eleifend in.",
    },
  },
}
export default ProjectPullquote
